module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/slider/image6-b3f63a9fb039c38c6cd2086cbb8333b6.jpg";